module.exports = __webpack_public_path__ + "static/no-dairy-839db5b05ac03f7cad98cbcd98d125a5.png";